import { useEffect } from 'react';

// DEPENDENCIES
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// MAIN COMPONENT
const AuthenticationRedirect = ({
  to
}) => {

  // REACT ROUTER
  const navigate = useNavigate();

  // REDUX
  const alerts = useSelector(({ alerts}) => alerts);

  // EFFECTS
  useEffect(
    () => {
      navigate(to, {
        replace: true,
        state: {
          alerts
        }
      });
    },
    [navigate, to, alerts]
  )

  return null;
}

// EXPORT
export default AuthenticationRedirect
